import { useQuery } from '@tanstack/react-query';
import accountsService from '@/lib/api/accounts';

export function useAccountDetail(
  organizationId: string | undefined,
  accountDomain: string | undefined,
  options?: { users_limit?: number; users_offset?: number },
) {
  return useQuery({
    queryKey: [
      'account-detail',
      organizationId,
      accountDomain,
      options?.users_limit,
      options?.users_offset,
    ],
    queryFn: async () => {
      if (!organizationId) throw new Error('Organization ID required');
      if (!accountDomain) throw new Error('Account domain required');

      const response = await accountsService.getAccountDetail(
        organizationId,
        accountDomain,
        options,
      );

      if (!response.success || !response.data) {
        throw new Error(response.error || 'Failed to fetch account detail');
      }
      return response.data;
    },
    enabled: !!organizationId && !!accountDomain,
    staleTime: 30 * 1000,
  });
}
